import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { copy, selectTransferPresentation } from "@aasaan-share/ui-contract";
import { videoTransferActionMode } from "../transfer-actions.ts";
import Icon from "./Icon.svelte";

var root = $.from_html(`<img alt=""/>`);
var root_1 = $.from_html(`<div class="dialog-loading">Loading poster...</div>`);
var root_2 = $.from_html(`<button class="secondary-button" data-action="cancel-download" type="button"> </button>`);
var root_3 = $.from_html(`<button class="primary-button" data-action="download-video" type="button"><!> </button> <button class="secondary-button" data-action="close-dialog" type="button"> </button>`, 1);
var root_4 = $.from_html(`<button class="primary-button" data-action="download-video" type="button"><!> </button>`);
var root_5 = $.from_html(`<dialog aria-labelledby="video-dialog-title" class="media-dialog video-dialog" data-dialog="video"><div class="dialog-shell video-shell"><header class="dialog-header"><h2 id="video-dialog-title"> </h2> <button class="icon-button" data-action="close-dialog" type="button"><!></button></header> <div class="video-poster"><!> <div class="video-summary"><span> </span> <span> </span></div></div> <div class="video-detail"><p> </p> <p data-transfer-copy=""> </p> <div aria-valuemax="100" aria-valuemin="0" class="progress-track" data-transfer-progress="" role="progressbar"><span data-transfer-progress-bar=""></span></div></div> <footer class="dialog-actions" data-transfer-actions=""><!></footer></div></dialog>`);

export default function VideoDialog($$anchor, $$props) {
	$.push($$props, true);

	let presentation = $.derived(() => $$props.transferState
		? selectTransferPresentation($$props.transferState)
		: undefined);

	let progressPercent = $.derived(() => Math.round(($$props.progress ?? 0) * 100));
	let actionMode = $.derived(() => videoTransferActionMode($$props.transferState));
	let active = $.derived(() => $.get(actionMode) === "active");
	var dialog = root_5();
	var div = $.child(dialog);
	var header = $.child(div);
	var h2 = $.child(header);
	var text = $.child(h2, true);

	$.reset(h2);

	var button = $.sibling(h2, 2);
	var node = $.child(button);

	Icon(node, { name: 'close' });
	$.reset(button);
	$.reset(header);

	var div_1 = $.sibling(header, 2);
	var node_1 = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var img = root();

			$.template_effect(() => $.set_attribute(img, 'src', $$props.media.source));
			$.append($$anchor, img);
		};

		var alternate = ($$anchor) => {
			var div_2 = root_1();

			$.append($$anchor, div_2);
		};

		$.if(node_1, ($$render) => {
			if ($$props.media.source) $$render(consequent); else $$render(alternate, -1);
		});
	}

	var div_3 = $.sibling(node_1, 2);
	var span = $.child(div_3);
	var text_1 = $.child(span, true);

	$.reset(span);

	var span_1 = $.sibling(span, 2);
	var text_2 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(div_3);
	$.reset(div_1);

	var div_4 = $.sibling(div_1, 2);
	var p = $.child(div_4);
	var text_3 = $.child(p, true);

	$.reset(p);

	var p_1 = $.sibling(p, 2);
	var text_4 = $.child(p_1, true);

	$.reset(p_1);

	var div_5 = $.sibling(p_1, 2);
	var span_2 = $.child(div_5);

	$.reset(div_5);
	$.reset(div_4);

	var footer = $.sibling(div_4, 2);
	var node_2 = $.child(footer);

	{
		var consequent_1 = ($$anchor) => {
			var button_1 = root_2();
			var text_5 = $.child(button_1, true);

			$.reset(button_1);
			$.template_effect(() => $.set_text(text_5, copy["action.cancel"]));
			$.append($$anchor, button_1);
		};

		var consequent_2 = ($$anchor) => {
			var fragment = root_3();
			var button_2 = $.first_child(fragment);
			var node_3 = $.child(button_2);

			Icon(node_3, { name: 'retry' });

			var text_6 = $.sibling(node_3);

			$.reset(button_2);

			var button_3 = $.sibling(button_2, 2);
			var text_7 = $.child(button_3, true);

			$.reset(button_3);

			$.template_effect(() => {
				$.set_attribute(button_2, 'data-media-id', $$props.media.id);
				$.set_text(text_6, ` ${copy["action.tryAgain"] ?? ''}`);
				$.set_text(text_7, copy["action.backToPhotos"]);
			});

			$.append($$anchor, fragment);
		};

		var alternate_1 = ($$anchor) => {
			var button_4 = root_4();
			var node_4 = $.child(button_4);

			Icon(node_4, { name: 'download' });

			var text_8 = $.sibling(node_4);

			$.reset(button_4);

			$.template_effect(() => {
				$.set_attribute(button_4, 'data-media-id', $$props.media.id);
				$.set_text(text_8, ` ${copy["action.downloadOriginal"] ?? ''}`);
			});

			$.append($$anchor, button_4);
		};

		$.if(node_2, ($$render) => {
			if ($.get(actionMode) === "active") $$render(consequent_1); else if ($.get(actionMode) === "failed") $$render(consequent_2, 1); else $$render(alternate_1, -1);
		});
	}

	$.reset(footer);
	$.reset(div);
	$.reset(dialog);

	$.template_effect(
		($0) => {
			$.set_attribute(dialog, 'data-media-id', $$props.media.id);
			$.set_text(text, $$props.media.label);
			$.set_attribute(button, 'aria-label', copy["action.close"]);
			$.set_attribute(button, 'title', copy["action.close"]);
			$.set_text(text_1, $$props.media.durationLabel ?? "");
			$.set_text(text_2, $$props.media.sizeLabel ?? "");
			$.set_text(text_3, copy["video.detail"]);
			$.set_attribute(p_1, 'aria-live', $.get(presentation)?.announce ? "polite" : undefined);

			$.set_class(p_1, 1, $.clsx($$props.transferState
				? `transfer-copy transfer-${$$props.transferState}`
				: "transfer-copy"));

			$.set_attribute(p_1, 'hidden', !$.get(presentation)?.copyKey);
			$.set_attribute(p_1, 'role', $.get(presentation)?.announce ? "status" : undefined);
			$.set_text(text_4, $.get(presentation)?.copyKey ? copy[$.get(presentation).copyKey] : "");
			$.set_attribute(div_5, 'aria-label', `${$.get(progressPercent)}%`);
			$.set_attribute(div_5, 'aria-valuenow', $0);
			$.set_attribute(div_5, 'hidden', !$.get(active));
			$.set_style(span_2, `width:${$.get(progressPercent)}%`);
		},
		[() => String($.get(progressPercent))]
	);

	$.append($$anchor, dialog);
	$.pop();
}